import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { BenchPage } from '@/features/bench';

/**
 * The packing bench. Permission `orders.print`, roles packer and owner. Typing the URL as
 * another role gets the API's 403 on the first call; the nav simply never offers it.
 */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/bench',
  component: BenchPage,
});
